import React from 'react'
import {
    Section,
    SectionTitle,
    WrapRow,
    RatioContainer,
} from '../../../../shared/shared.styled'
import { useFormikContext } from 'formik'
import { Sale } from '../../../sales.interfaces'
import PdfGeneratorButton from '../../../../shared/components/button2.component'
import {
    enqueueSaleDocument,
    enqueueCompanyPricelist,
} from '../../../../api/celeryClient'
import { useAlert } from 'react-alert'
import { Vehicle } from '../../../../shared/shared.models'
import useArtifactDownload from '../../../../hooks/useArtifactDownload'

interface DocumentsSectionProps {
    vehicle: Vehicle
    typePDF?: string
    company?: string
    vehicleUuid?: string
}

export const DocumentsSection = ({
    vehicle,
    typePDF = '',
    company = '',
    vehicleUuid = '',
}: DocumentsSectionProps) => {
    const { values } = useFormikContext<Sale>()

    const alert = useAlert()

    const { busy, startTask } = useArtifactDownload({
        getFilename: (result) =>
            result.filename || `${vehicle?.licensePlate} - Documento`,
        successMessage: 'O PDF será transferido automaticamente',
        failureMessage: 'Erro ao gerar o PDF. Por favor tente mais tarde',
        defaultContentType: 'application/pdf',
    })

    const enqueueAndPoll = async (typePDF: string, withPrice = false) => {
        if (busy) return
        try {
            if (typePDF === 'pricelist') {
                const comp = company || ''
                const vid = vehicleUuid || ''
                const res = await enqueueCompanyPricelist(comp, vid, withPrice)
                startTask(res.task_id)
            } else {
                const res = await enqueueSaleDocument(values?.uuid, typePDF)
                startTask(res.task_id)
            }
        } catch (err) {
            console.error(err)
            alert.error('Erro ao enfileirar a geração do documento')
        }
    }

    return (
        <Section>
            <SectionTitle>Documentos</SectionTitle>
            {typePDF === 'pricelist' ? (
                <WrapRow>
                    <RatioContainer ratio={1 / 3}>
                        <PdfGeneratorButton
                            icon={'/icons/pdf.png'}
                            action={() => enqueueAndPoll('pricelist', false)}
                            title={'Preçário sem preço'}
                            disabled={busy}
                        />
                    </RatioContainer>
                    <RatioContainer ratio={1 / 3}>
                        <PdfGeneratorButton
                            icon={'/icons/pdf.png'}
                            action={() => enqueueAndPoll('pricelist', true)}
                            title={'Preçário'}
                            disabled={busy}
                        />
                    </RatioContainer>
                </WrapRow>
            ) : (
                <>
                    <WrapRow>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('circulation')}
                                title={'Autorização de circulação'}
                                disabled={busy}
                            />
                        </RatioContainer>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('contract')}
                                title={'Contrato'}
                                disabled={busy}
                            />
                        </RatioContainer>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('warranty')}
                                title={'Garantia'}
                                disabled={busy}
                            />
                        </RatioContainer>
                    </WrapRow>
                    <WrapRow>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('material')}
                                title={'Material'}
                                disabled={busy}
                            />
                        </RatioContainer>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('fines')}
                                title={'Multas'}
                                disabled={busy}
                            />
                        </RatioContainer>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('privacy')}
                                title={'Privacidade'}
                                disabled={busy}
                            />
                        </RatioContainer>
                    </WrapRow>
                    <WrapRow>
                        <RatioContainer ratio={1 / 3}>
                            <PdfGeneratorButton
                                icon={'/icons/pdf.png'}
                                action={() => enqueueAndPoll('retake')}
                                title={'Retoma'}
                                disabled={busy}
                            />
                        </RatioContainer>
                    </WrapRow>
                </>
            )}
        </Section>
    )
}
